export enum ThemeKeys {
  textColor = "textColor",
  scrollbarColor = "scrollbarColor",
  infoBg = "infoBg",
  navButtonColor = "navButtonColor",
  resultsHeadlineSize = "resultsHeadlineSize",
}

export enum TextColorThemeTypes {
  Default = "Default",
  Light = "Light",
}

export enum LanguageLabels {
  en = "en",
  de = "de",
}
export enum Languages {
  en = "report",
  de = "bericht",
}

export enum LanguagesSubdomains {
  en = "report2020",
  de = "bericht2020",
}
